import React, { useEffect, useState } from "react";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { Form } from "react-bootstrap";
import HolidayService from "../../services/holiday.service";

import moment from "moment";

const EditHoliday = ({
  holidayData,
  editHoliday,
  setEditHoliday,
  fetchHolidayList,
}) => {
  const [validated, setValidated] = useState(false);

  const [details, setDetails] = useState({
    holidayName: "",
    holidayDate: "",
    holidayType: "",
    id: "",
  });

  // console.log(holidayData);

  useEffect(() => {
    if (editHoliday) {
      setDetails({
        holidayName: holidayData.hname,
        holidayDate: moment(new Date(holidayData.date)).format("YYYY-MM-DD"),
        holidayType: holidayData.htype,
        id: holidayData.editId,
      });
    }
  }, [editHoliday, holidayData]);

  const handleChnage = (e) => {
    const { name, value } = e.target;
    setDetails({ ...details, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    e.stopPropagation();

    const form = e.currentTarget;

    if (form.checkValidity() === false) {
      setValidated(true);
      toast.warn("* Please fill all required fields!", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      return;
    }

    const data = {
      hname: details.holidayName,
      date: details.holidayDate,
      htype: details.holidayType,
      id: details.id,
    };

    // console.log(data);

    HolidayService.editHoliday(data)
      .then((resp) => {
        if (resp.data) {
          fetchHolidayList();
          toast.success("Holiday Updated Successfully", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            onClose: () => setEditHoliday(false),
          });
        }
      })
      .catch((e) => console.log(e));
  };

  return (
    <>
      <div
        className={`${
          editHoliday
            ? "add-event feedback policy visible"
            : "add-event feedback policy hidden"
        }`}
      >
        <div className="flex mb-5">
          <div className="left-flex mb-4">
            <span>Edit Holiday </span>
          </div>

          <ToastContainer />

          <Form noValidate validated={validated} onSubmit={handleSubmit}>
            <div className="event-form scroll">
              <div className="mb-3">
                <label htmlFor="" className="form-label">
                  Holiday Name
                </label>
                <input
                  type="text"
                  className="form-control"
                  name="holidayName"
                  value={details.holidayName}
                  onChange={handleChnage}
                  required
                />
              </div>
              <div className="mb-3">
                <label htmlFor="" className="form-label">
                  Holiday Date
                </label>
                <input
                  type="date"
                  className="form-control"
                  name="holidayDate"
                  value={details.holidayDate}
                  onChange={handleChnage}
                  required
                />
              </div>
              <div className="mb-3">
                <label htmlFor="" className="form-label">
                  Holiday Type
                </label>
                <select
                  className="form-select"
                  name="holidayType"
                  value={details.holidayType}
                  onChange={handleChnage}
                  required
                >
                  <option value="NA">Select</option>
                  <option value="Full Day">Full Day</option>
                  <option value="Half Day">Half Day</option>
                </select>
              </div>
            </div>

            <div className="sort-action">
              <button className="btn btn-reset">Reset</button>
              <button className="btn btn-apply">Update</button>
            </div>
          </Form>
        </div>
      </div>
    </>
  );
};

export default EditHoliday;
